import { jsx as r } from "react/jsx-runtime";
import { s as e } from "../checks-C6AyTTQ0.js";
import { Button as s } from "../Button/Button.js";
import { ButtonsContainer as a } from "../ButtonsContainer/ButtonsContainer.js";
const i = "InclusionsDrawerFooterCta-module_button-cta__J3gQZ",
  m = {
    buttonCta: i
  },
  h = _ref => {
    let {
      fullPath: t,
      ctaLabel: o
    } = _ref;
    const n = e(t);
    return /* @__PURE__ */r(a, {
      align: "right",
      children: n && /* @__PURE__ */r(s, {
        renderAs: "a",
        href: t,
        variant: "text",
        iconName: "arrow-right",
        dataContentPiece: "more_button",
        className: m.buttonCta,
        size: "small",
        children: o && o
      })
    });
  };
export { h as InclusionsDrawerFooterCta };